'use strict';require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/icon/style/css.web.js
// module id = 209
// module chunks = 0